// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__10Vj_","buttons":"Footer_buttons__2PrEr"};